export const container = ({ isDesktop }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  marginTop: isDesktop ? "10px" : "0px",
  gap: "8px",
});

export const noticeText = ({ isDesktop }) => ({
  fontFamily: "body",
  fontSize: isDesktop ? "20px" : "14px",
  lineHeight: isDesktop ? "20px" : "14px",
  letterSpacing: "0.025em",
  textTransform: "uppercase",
  fontWeight: "body",
});
